/* eslint-disable camelcase */
import React from 'react'
import ViralOnTikTokBadge from 'components/ViralOnTikTokBadge'

// const ANALYTICS_EVENT = {
//   SHOW_VIRAL_ON_TIK_TOK_BADGE: 'SHOW_VIRAL_ON_TIK_TOK_BADGE'
// }

/**
 * @param {ProductBadgesProps} props
 * @returns {JSX.Element}
 * @constructor
 */
export default function ProductBadgeViralOnTikTok (props) {
  const {
    isViralOnTikTok
  } = props

  const isHidden = !isViralOnTikTok

  if (isHidden) {
    return <></>
  }

  return (
    <ViralOnTikTokBadge />
  )
}
